
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5646',
  depVersions: {
  "data-privacy-request-ui": "static-1.5646",
  "data-fetching-client": "static-1.9790",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8150",
  "hub-http-shared-msw-handlers": "static-1.10284",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11599",
  "I18n": "static-7.1641",
  "jasmine-runner": "static-1.6586",
  "privacy-center-public-service-types": "static-1.4909",
  "quartz": "static-1.7201",
  "react-dlb": "static-1.81",
  "ui-components-test-utils": "static-1.5736",
  "UIComponents": "static-3.8545",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.87",
  "foundations-assets": "static-1.5004",
  "foundations-components": "static-1.8190",
  "foundations-components-test-utils": "static-1.5673",
  "foundations-theming": "static-1.4562",
  "hub-http": "static-1.6351",
  "quartz-config": "static-1.979",
  "quartz-core": "static-1.6420",
  "quartz-routing": "static-1.631",
  "quick-fetch": "static-1.4014",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-rhumb": "static-1-feature-id-1459-lcp-embedded-fields.3",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11278",
  "usage-tracker": "static-1.7480",
  "usage-tracker-anonymous": "static-1.5897",
  "usage-tracker-core": "static-1.7330",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3495",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3478",
  "quartz-webpack": "static-1.3425",
  "bend-plugin-quartz-routing": "static-1.279",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "HeadJS": "static-2.773",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3261",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "ts-schema": "static-1.4179",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "react-utils": "static-2.5438",
  "StyleGuideUI": "static-3.489",
  "jasmine": "static-4.4454",
  "rpc-client-utils": "static-1.4786",
  "HubStyle": "static-2.11906",
  "ui-addon-draggable": "static-3.4890",
  "cssUtils": "static-1.829",
  "hs-story-utils": "static-1.9552",
  "icons": "static-2.656",
  "react-create-root-preference": "static-1.39",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1188",
  "bend-plugin-foundations-components": "static-1.4459",
  "floating-ui": "static-1.58",
  "foundations-theming-specialty": "static-1.2278",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2214",
  "ui-fonts": "static-1.861",
  "foundations-components-legacy": "static-1.1215",
  "bend-plugin-foundations-theming": "static-1.3045",
  "foundations-theming-base": "static-1.3547",
  "stylex": "static-1.35",
  "hs-locale-management": "static-1.177",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.848",
  "hubspotter-http": "static-1.4747",
  "mobile-manifest-mixins": "static-1.547",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.876",
  "quartz-head": "static-1.866",
  "quartz-i18n": "static-1.876",
  "quartz-test": "static-1.876",
  "quartz-tracking": "static-1.580",
  "trellis-components": "static-1.2233",
  "usage-tracker-container": "static-1.7470",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3301",
  "bend-plugin-chirp-manifest": "static-1.196",
  "chirp-fetch": "static-1.2018",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.72",
  "sassPrefix": "static-1.158",
  "hubspotter-http-shared-msw-handlers": "static-1.10282",
  "usage-tracker-session-replay": "static-1.5166",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1072",
  "tanstack-virtual": "static-1.31",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5646",
  "data-fetching-client": "/data-fetching-client/static-1.9790",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8150",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10284",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11599",
  "I18n": "/I18n/static-7.1641",
  "jasmine-runner": "/jasmine-runner/static-1.6586",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4909",
  "quartz": "/quartz/static-1.7201",
  "react-dlb": "/react-dlb/static-1.81",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5736",
  "UIComponents": "/UIComponents/static-3.8545",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "foundations-assets": "/foundations-assets/static-1.5004",
  "foundations-components": "/foundations-components/static-1.8190",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5673",
  "foundations-theming": "/foundations-theming/static-1.4562",
  "hub-http": "/hub-http/static-1.6351",
  "quartz-config": "/quartz-config/static-1.979",
  "quartz-core": "/quartz-core/static-1.6420",
  "quartz-routing": "/quartz-routing/static-1.631",
  "quick-fetch": "/quick-fetch/static-1.4014",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-lcp-embedded-fields.3",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11278",
  "usage-tracker": "/usage-tracker/static-1.7480",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5897",
  "usage-tracker-core": "/usage-tracker-core/static-1.7330",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3495",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3478",
  "quartz-webpack": "/quartz-webpack/static-1.3425",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.279",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "HeadJS": "/HeadJS/static-2.773",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3261",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "ts-schema": "/ts-schema/static-1.4179",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "react-utils": "/react-utils/static-2.5438",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "jasmine": "/jasmine/static-4.4454",
  "rpc-client-utils": "/rpc-client-utils/static-1.4786",
  "HubStyle": "/HubStyle/static-2.11906",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4890",
  "cssUtils": "/cssUtils/static-1.829",
  "hs-story-utils": "/hs-story-utils/static-1.9552",
  "icons": "/icons/static-2.656",
  "react-create-root-preference": "/react-create-root-preference/static-1.39",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1188",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4459",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2278",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2214",
  "ui-fonts": "/ui-fonts/static-1.861",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1215",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3045",
  "foundations-theming-base": "/foundations-theming-base/static-1.3547",
  "stylex": "/stylex/static-1.35",
  "hs-locale-management": "/hs-locale-management/static-1.177",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.848",
  "hubspotter-http": "/hubspotter-http/static-1.4747",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.876",
  "quartz-head": "/quartz-head/static-1.866",
  "quartz-i18n": "/quartz-i18n/static-1.876",
  "quartz-test": "/quartz-test/static-1.876",
  "quartz-tracking": "/quartz-tracking/static-1.580",
  "trellis-components": "/trellis-components/static-1.2233",
  "usage-tracker-container": "/usage-tracker-container/static-1.7470",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.196",
  "chirp-fetch": "/chirp-fetch/static-1.2018",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.72",
  "sassPrefix": "/sassPrefix/static-1.158",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10282",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5166",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1072",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
